// CSS
import '../scss/index.scss';

// Polyfills
import './lib/polyfills';

// Vendors
import $ from 'jquery';
import 'fancybox/dist/js/jquery.fancybox.pack';
import 'jquery.maskedinput/src/jquery.maskedinput';
import './lib/wl-share';

// Framework
import carousels from './framework/carousel';
import code from './framework/code';
import dropdowns from './framework/dropdown';
import modals from './framework/modal';
import notices from './framework/notice';
import toggles from './framework/toggle';
import tooltips from './framework/tooltip';
import utilities from './framework/utilities';

// Site modules
import './site/aos';
import './site/scrolling-grid';
import './site/back-to-top';
import './site/home-animation';
import './site/mobile-nav';
import './site/newsroom';
import './site/header-search';
import './site/search-autosuggest';
import './site/side-nav';
import './site/sticky-header';
import './site/hero-parallax';
import './site/parallax-cards';
import './site/video-modals';
import './site/youtube-video';
import './site/video-block';
import './site/steps-block';
import './site/video-row';

// Apply input masks
$('.mask-input-phone').mask('(999) 999-9999');
$('.mask-input-date').mask('99/99/9999');

// Init Fancybox
$('.fancybox').fancybox({
  helpers: {
    overlay: {
      locked: false // Prevent page from jumping back to top
    }
  }
});

// Init card media carousel (image collages on story cards)
const carouselCardMedia = carousels('[data-carousel="card-media"]', {
  autoplay: false,
  dots: true,
  arrows: false,
  infinite: true,
  speed: 400
});

// Init single carousel
const carouselSingle = carousels('[data-carousel="single"]', {
  autoplay: false,
  dots: true,
  infinite: true,
  speed: 500
});

// Init multiple carousel
const carouselMultiple = carousels('[data-carousel="multiple"]', {
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
  ]
});

// Init timeline carousel
const carouselTimelineLg = carousels('[data-carousel="timeline_lg"]', {
  autoplay: false,
  dots: false,
  arrows: true,
  asNavFor: '.carousel-dot-container-lg',
  infinite: false,
  slidesToShow: 2,
  slidesToScroll: 1,
  speed: 1100
});

const carouselTimelineNavLg = carousels('[data-carousel="timeline_nav_lg"]', {
  slidesToShow: 13,
  slidesToScroll: 1,
  asNavFor: '.timeline-carousel-lg',
  centerMode: false,
  focusOnSelect: true,
  arrows: false,
  infinite: false,
  responsive: [
    {
      breakpoint: 1330,
      settings: {
        slidesToShow: 8
      }
    }
  ]
});

const carouselTimelineSm = carousels('[data-carousel="timeline_sm"]', {
  autoplay: false,
  dots: false,
  arrows: false,
  asNavFor: '.carousel-dot-container-sm',
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  speed: 500
});

const carouselTimelineNavSm = carousels('[data-carousel="timeline_nav_sm"]', {
  slidesToShow: 4,
  slidesToScroll: 2,
  asNavFor: '.timeline-carousel-sm',
  centerMode: false,
  focusOnSelect: true,
  arrows: false,
  infinite: false
});

const logoSliderLg = carousels('[data-carousel="logo-slider-lg"]', {
  autoplay: true,
  dots: false,
  arrows: false,
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplaySpeed: 0,
  speed: 4000,
  cssEase: 'linear',
  draggable: false,
  swipe: false,
  pauseOnFocus: false,
  pauseOnHover: false
});

const logoSliderMd = carousels('[data-carousel="logo-slider-md"]', {
  autoplay: true,
  dots: false,
  arrows: false,
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplaySpeed: 0,
  speed: 7000,
  cssEase: 'linear',
  draggable: false,
  swipe: false,
  pauseOnFocus: false,
  pauseOnHover: false
});

const logoSliderSm = carousels('[data-carousel="logo-slider-sm"]', {
  autoplay: true,
  dots: false,
  arrows: false,
  infinite: true,
  slidesToShow: 2,
  slidesToScroll: 1,
  autoplaySpeed: 0,
  speed: 7000,
  cssEase: 'linear',
  draggable: false,
  swipe: false,
  pauseOnFocus: false,
  pauseOnHover: false
});

// Init Hero Carousel
const heroHomeSlider = carousels('[data-carousel="hero-home"]', {
  autoplay: true,
  dots: true,
  autoplaySpeed: 7000,
  infinite: true,
  cssEase: 'linear',
  speed: 800,
  arrows: false,
  pauseOnFocus: false,
  pauseOnHover: false
});

const $homeSliderNew = $('[data-carousel="home-new"]');

function resetAnimations($slide) {
  // $slide.find('[data-animate]').css({
  //   opacity: 0,
  //   transform: 'translateY(20px)',
  //   transitionDelay: '0s'
  // });
  $slide.removeClass('animate-in');
}

$homeSliderNew.on('init', function (event, slick) {
  const $firstSlide = $(slick.$slides.get(0));
  resetAnimations($firstSlide);
  setTimeout(() => $firstSlide.addClass('animate-in'), 50);
});

$homeSliderNew.on('beforeChange', function (event, slick, currentSlide) {
  resetAnimations($(slick.$slides.get(currentSlide)));
});

$homeSliderNew.on('afterChange', function (event, slick, currentSlide) {
  const $currentSlide = $(slick.$slides.get(currentSlide));
  setTimeout(() => $currentSlide.addClass('animate-in'), 50);
});

// Init after events bound
$homeSliderNew.slick({
  dots: true,
  arrows: false,
  infinite: true,
  speed: 500,
  fade: true,
  cssEase: 'linear',
  autoplay: true,
  autoplaySpeed: 5000
});

// Init modals
modals('[data-modal]');

// Init toggles
toggles('[data-toggle-target]');

// Init notices
notices('[data-notice-dismissible]');

// Init code
code('[data-code]');

// Init tooltips
tooltips('[data-tooltip]');

// Init dropdowns
dropdowns('[data-dropdown]');
